import { TeamsListResponseSchema, type TeamsListResponse } from '@/types/teams';
import { apiRequest } from './client';

const BASE = '/api/v1/teams';

export interface GetTeamsParams {
  season_id?: string; // uuid
  limit?: number; // default 50, max 100
  offset?: number; // default 0
  search?: string; // search by team name
}

export async function getTeams(params: GetTeamsParams = {}): Promise<TeamsListResponse> {
  const query = new URLSearchParams();
  if (params.season_id) query.set('season_id', params.season_id);
  if (params.limit !== undefined) query.set('limit', String(params.limit));
  if (params.offset !== undefined) query.set('offset', String(params.offset));
  if (params.search) query.set('search', params.search);

  const qs = query.toString();
  const url = `${BASE}${qs ? `?${qs}` : ''}`;
  const res = await apiRequest<unknown>({ url, method: 'GET' });
  return TeamsListResponseSchema.parse(res);
}

